import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import HubSectionCard from '../components/cards/HubSectionCard';
import ParentsCard from '../components/cards/ParentsCard';
import parentsResources from '../cms/parents.json';
import hubs from '../cms/hubs.json';
import '../css/pages/Parents.css';

const Parents = () => {
  const hub = hubs.parents || {};
  const parentSections = hub.cards || [];

  const getConnectedResources = parentsResources.filter(resource => 
    resource.icon === 'facebook' || resource.icon === 'network'
  );

  return (
    <>
      <PageHeader 
        title={hub.pageTitle} 
        subtitle={hub.pageSubtitle}
        showLogo={true}
      />
      
      <div className="parents-container">
        <section className="parents-sections">
          <div className="sections-grid">
            {parentSections.map((section) => (
              <HubSectionCard key={section.path || section.externalUrl || section.title} card={section} />
            ))}
          </div>
        </section>

        <section className="parents-direct-links">
          <h2>Quick Connect</h2>
          <div className="direct-links-grid">
            {getConnectedResources.map((resource) => (
              <ParentsCard key={resource.id} resource={resource} />
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default Parents; 